export default {
  'Screenshot': 'Screenshot',
}